<template>
    <BreadCrumb PageTitle="Liste des Ticket" />
    <ListeTicket />
</template>

<script lang="ts">
    import { defineComponent } from "vue";

    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeTicket from "../../components/Ticket/ListeTicket.vue";

    export default defineComponent({
        name: "ListeTicketPage",
        components: {
            BreadCrumb,
            ListeTicket,
        },
    });
</script>